document.addEventListener("DOMContentLoaded", function () {
    // Select all tab links and tab panes
    const tabLinks = document.querySelectorAll(".nav-tabs li a");
    const tabPanes = document.querySelectorAll(".tab-content .tab-pane");

    // Function to deactivate all tabs and panes
    function deactivateAllTabs() {
        tabLinks.forEach((link) => {
            link.parentElement.classList.remove("active");
        });
        tabPanes.forEach((pane) => {
            pane.classList.remove("active");
            pane.style.display = "none"; // Hide all tab panes
        });
    }

    // Function to activate a specific tab and pane
    function activateTab(tabLink) {
        const targetId = tabLink.getAttribute("href"); // Get the target pane ID
        const targetPane = document.querySelector(targetId);

        if (targetPane) {
            tabLink.parentElement.classList.add("active"); // Activate the tab
            targetPane.classList.add("active"); // Activate the pane
            targetPane.style.display = "block"; // Show the tab pane
        }
    }

    // Initialize tabs: Set the first tab and pane as active
    if (tabLinks.length > 0) {
        deactivateAllTabs(); // Ensure all tabs are reset
        activateTab(tabLinks[0]); // Activate the first tab
    }

    // Add click event listener to all tab links
    tabLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
            e.preventDefault(); // Prevent default anchor behavior
            deactivateAllTabs(); // Deactivate all tabs and panes
            activateTab(this); // Activate the clicked tab and its pane
        });
    });
});
